<template>
    <v-card flat tile class="empty-screen-container">
        <v-icon class="empty-icon theme-hightext">{{$route.meta.icon}}</v-icon>
        <v-card flat tile class="empty-title theme-title">{{$route.meta.title}}</v-card>
    </v-card>
</template>

<script>
    import eventBus from '@/eventBus';

    export default {
        name: "EmptyScreen",
      mounted() {
        eventBus.$emit('GAMESYNCDIALOG_CLOSE');
      }
    }
</script>

<style scoped>
    .empty-screen-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: column;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
    }

    .empty-icon {
        font-size: 80px;
    }

    .empty-title {
        margin-top: 25px;
        font-size: 24px;
    }
</style>
